import { Tab, Tabs } from '@mui/material'
import { SyntheticEvent, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { LayoutWithTitleAndInfo, PageLayout, TabPanel } from '../..'
import { useIsMobile } from '../../../contexts'
import { useRedirect } from '../../../hooks'
import { HorizontalTabLinkProps } from '../types'

type HorizontalTabLayoutProps = {
  openTab: string
  tabProps: HorizontalTabLinkProps[]
}

export const HorizontalTabLayout = ({
  openTab,
  tabProps
}: HorizontalTabLayoutProps) => {
  const { redirect } = useRedirect()
  const isMobile = useIsMobile()

  const visibleTabProps = tabProps.filter(
    (tabProp) => tabProp.isHidden !== true
  )
  const indexOfOpenTab = visibleTabProps
    .map((tabProp) => tabProp.tab)
    .indexOf(openTab)
  const [selectedTab, setSelectedTab] = useState(indexOfOpenTab)

  // Needed for updating content when user uses browser's history back button
  useEffect(() => {
    if (selectedTab !== indexOfOpenTab) {
      setSelectedTab(indexOfOpenTab)
    }
  }, [indexOfOpenTab, selectedTab])

  const handleTabChange = (
    _event: SyntheticEvent<Element, Event>,
    newTab: number
  ) => {
    setSelectedTab(newTab)
    redirect(visibleTabProps[newTab].to) // updating browser's url
  }

  return (
    <PageLayout>
      <Tabs
        indicatorColor="secondary"
        onChange={handleTabChange}
        sx={{
          mb: '1.5rem'
        }}
        textColor="secondary"
        value={selectedTab}
      >
        {visibleTabProps.map((tabProp, index) => {
          const { key, translationId } = tabProp

          return (
            <Tab
              key={`horizontal-tab-${key}-${index}`}
              label={<FormattedMessage id={translationId} />}
              sx={{
                mr: isMobile ? '20px' : '80px'
              }}
            />
          )
        })}
      </Tabs>
      {visibleTabProps.map((tabProp, index) => {
        const { infoBoxProps, key, TabElement } = tabProp
        return (
          <TabPanel
            index={index}
            key={`horizontal-tabpanel-${key}-${index}`}
            prefix="horizontal"
            selectedTab={selectedTab}
          >
            <LayoutWithTitleAndInfo infoBoxProps={infoBoxProps}>
              <TabElement />
            </LayoutWithTitleAndInfo>
          </TabPanel>
        )
      })}
    </PageLayout>
  )
}
